import { loadSlider } from '../shared/utils/swiper';

const setupFeaturedGuides = async () => {
  const featuredGuides = document.querySelectorAll<HTMLElement>(
    '.js-async-featured-guides'
  );
  featuredGuides?.forEach((featuredGuide) => {
    loadSlider(featuredGuide, {});
  });
};
setupFeaturedGuides();
